import { render, staticRenderFns } from "./HomeResultsList.vue?vue&type=template&id=1742a210&"
import script from "./HomeResultsList.vue?vue&type=script&lang=js&"
export * from "./HomeResultsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports